/** @file URL定数 */

/** アプリストア定義 */
export const APP_STORE_URL = Object.freeze({
  APPLE_STORE_URL: 'https://itunes.apple.com/jp/app/id944884603',
  PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.coconala.android.portal'
})

export const BUSINESS_DOCUMENT_DOWNLOAD_LINK = 'https://coconala.com/r/document_dl'
export const BUSINESS_CONTACT_LINK = 'https://forms.gle/MFQdjZntK2327nn99'

// アプリのネイティブの機能を呼び出す
// SMS認証ダイアログを起動する
export const APP_TRIGGER_SMS_CERTIFICATION = 'coconala://viewscreen/sms'
// シェアダイアログを開く
export const APP_TRIGGER_SHARE = 'coconala://viewscreen/share'
